import React from "react";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto py-16 px-4">
      <h1 className="text-4xl font-bold mb-4 text-gradient bg-gradient-to-r from-indigo-500 via-pink-500 to-purple-500 bg-clip-text text-transparent">About Inflatein AI Studio</h1>
      <p className="text-lg text-gray-700 mb-6">Inflatein AI Studio empowers creators, businesses, and developers to transform ideas into stunning visuals using cutting-edge AI. Our mission is to make high-quality image generation accessible, fast, and delightful for everyone.</p>
      <h2 className="text-2xl font-semibold mt-8 mb-2">Our Story</h2>
      <p className="text-gray-600 mb-4">Founded in 2024, Inflatein AI Studio was born from a passion for creativity and technology. Our team brings together AI researchers, designers, and engineers to build tools that inspire and enable innovation.</p>
      <h2 className="text-2xl font-semibold mt-8 mb-2">Our Values</h2>
      <ul className="list-disc pl-6 text-gray-600 mb-4">
        <li>Innovation & Excellence</li>
        <li>User-Centric Design</li>
        <li>Transparency & Trust</li>
        <li>Community & Collaboration</li>
      </ul>
      <h2 className="text-2xl font-semibold mt-8 mb-2">Contact</h2>
      <p className="text-gray-600">Have questions? <a href="/contact" className="text-indigo-600 underline">Contact us</a> or email <a href="mailto:support@inflatein.com" className="text-indigo-600 underline">support@inflatein.com</a>.</p>
    </div>
  );
}
